import {
  ClipboardList, Mic, ShieldCheck, Video,
} from 'lucide-react';

const FEATURES = [
  {
    icon: ClipboardList,
    title: 'Dokumentationszentrale',
    description: 'Patientenakte, Verlaufsnotizen und GNCP-Struktur an einem Ort. Die fachliche Bewertung bleibt bei der Therapeutin oder dem Therapeuten.',
  },
  {
    icon: Mic,
    title: 'Voice-to-Doku',
    description: 'Sitzungen aufzeichnen, transkribieren und als prüfbaren Dokumentationsentwurf vorbereiten lassen.',
  },
  {
    icon: Video,
    title: 'Teletherapie & Praxisbetrieb',
    description: 'Termine, Videositzungen, Aufgaben, Nachrichten und Patientenportal für den Alltag in der Ernährungstherapie.',
  },
  {
    icon: ShieldCheck,
    title: 'Klare KI-Grenze',
    description: 'Die KI sortiert, formuliert und bereitet vor. Sie priorisiert nicht, diagnostiziert nicht und empfiehlt keine Therapie.',
  },
];

export const Features = () => (
  <section className="py-20">
    <div className="max-w-6xl mx-auto px-6">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          Die Schaltzentrale für Ernährungstherapie
        </h2>
        <p className="text-gray-600 mt-3 max-w-lg mx-auto">
          Alles, was die Praxis täglich braucht - ohne medizinische Vorentscheidung durch Software.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        {FEATURES.map(({ icon: Icon, title, description }) => (
          <div
            key={title}
            className="bg-card rounded-2xl border-2 border-gray-100 shadow-sm p-6 hover:border-primary/30 hover:shadow-md transition-all"
          >
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
              <Icon className="w-5 h-5 text-primary" />
            </div>
            <h3 className="font-semibold text-gray-900">{title}</h3>
            <p className="text-sm text-gray-600 mt-2 leading-relaxed">{description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
